module.exports = __webpack_public_path__ + "static/media/img (sudan website).89eef3f6.png";